 
import {useQuery, gql} from "@apollo/client";
var CAREERS = gql`
query MyQuery {
    careers(where: {localization: {culture_starts_with: "fa"}}) {
      htmlBody {
        html
      }
      displayText
    }
  }
`;
export const useCareers = () => {
  const {error, data, loading} = useQuery(CAREERS);
  return {
    error,
    data,
    loading
  }
}